import styled from 'styled-components';

export const UserInfoList = styled.dl`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.m};
  background-color: ${({ theme }) => theme.colors.grey};
  padding: ${({ theme }) => theme.spacing.m};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.shadows.shadow2};
  dt {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.grey6};
  }

  dd {
    margin: 0;
    color: ${({ theme }) => theme.colors.grey4};
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => theme.spacing.s};
  }
`;

export const GreySection = styled.div`
  background-color: ${({ theme }) => theme.colors.grey};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.xs};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.shadows.shadow3};
  margin-bottom: ${({ theme }) => theme.spacing.m};
  transition:
    background-color 0.3s ease,
    box-shadow 0.3s ease;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.shadow4};
  }

  h6 {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.grey7};
  }

  select {
    &:focus {
      border-color: ${({ theme }) => theme.colors.primary};
      outline: none;
    }
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing.s};

    select {
      width: 100%;
    }
  }
`;

export const UserSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.l};
  margin-block: ${({ theme }) => theme.spacing.l};
  padding: ${({ theme }) => theme.spacing.m};
  border-radius: ${({ theme }) => theme.borderRadius};
  background-color: ${({ theme }) => theme.colors.offWhite};
  box-shadow: ${({ theme }) => theme.shadows.shadow2};
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: ${({ theme }) => theme.shadows.shadow4};
  }

  h3 {
    margin-top: ${({ theme }) => theme.spacing.s};
    color: ${({ theme }) => theme.colors.grey7};
  }

  @media screen and (max-width: 768px) {
    padding: ${({ theme }) => theme.spacing.s};
  }
`;
